// extracted by mini-css-extract-plugin
export default {"home-content":"home_home-content__a4iu6"};